import { RolesPageState, MgState } from '@types';

export const rolesPageSelector = (store: MgState): RolesPageState => store.rolesPage;
